/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A published advisory the decision's snapshot did not carry.
 */
export type EvidenceAdvisoryChange = {
  /**
   * The advisory identifier.
   */
  id: string;
  /**
   * The advisory's severity, when the database published one.
   */
  severity?: string | undefined;
  /**
   * The advisory's summary, when the database published one.
   */
  summary?: string | undefined;
};

/** @internal */
export const EvidenceAdvisoryChange$inboundSchema: z.ZodMiniType<
  EvidenceAdvisoryChange,
  unknown
> = z.object({
  id: z.string(),
  severity: z.optional(z.string()),
  summary: z.optional(z.string()),
});

export function evidenceAdvisoryChangeFromJSON(
  jsonString: string,
): SafeParseResult<EvidenceAdvisoryChange, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvidenceAdvisoryChange$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvidenceAdvisoryChange' from JSON`,
  );
}
